module.exports = __webpack_public_path__ + "images/icons_v2/star-full-green-34198c32.svg";